module Custom.Html (overlay, eqVDom, unfoldPlainHTML, unfoldHTML) where

import Prelude hiding (div)

import Data.Array (length, (!!))
import Data.Bifunctor (lmap)
import Data.Either (Either(..), either)
import Data.Maybe (Maybe(..))
import Data.Tuple (Tuple(..))
import Halogen (ClassName(..))
import Halogen.HTML (HTML, PlainHTML, div)
import Halogen.HTML.Core (renderWidget, widget)
import Halogen.HTML.Properties (class_, classes)
import Halogen.VDom (VDom(..), runGraft)

overlay ::
  forall slot action.
  Array ClassName ->
  Array (HTML slot action) ->
  HTML slot action
overlay panel_classes contents =
  div
    [ class_ $ ClassName "overlay" ]
    [ div
        [ classes panel_classes ]
        [ div [ class_ $ ClassName "overlay_content" ] contents ]
    ]

unfoldPlainHTML :: forall a. (a -> HTML a Void) -> a -> PlainHTML
unfoldPlainHTML c = unfoldHTML (lmap Left <<< c)

unfoldHTML :: forall a w i. (a -> HTML (Either a w) i) -> a -> HTML w i
unfoldHTML c = u
  where
  u x = renderWidget identity (either u widget) $ c x

eqArray :: forall a. (a -> a -> Boolean) -> Array a -> Array a -> Boolean
eqArray eqElem l r = length l == length r && loop (length l) 0
  where
  -- eqIndexed Nothing Nothing is False but should never occur.
  eqIndexed (Just le) (Just re) = eqElem le re
  eqIndexed _ _ = false
  loop ll = lloop
    where
    lloop i =
      if ll <= i then true else eqIndexed (l !! i) (r !! i) && lloop (1 + i)

eqTuple ::
  forall x y.
  (x -> x -> Boolean) ->
  (y -> y -> Boolean) ->
  Tuple x y ->
  Tuple x y ->
  Boolean
eqTuple eqX eqY (Tuple lx ly) (Tuple rx ry) = eqX lx rx && eqY ly ry

-- Internally uses 'runGrafted', which can we expensive, especially if done repeatedly.
eqVDom ::
  forall a w.
  (a -> a -> Boolean) ->
  (w -> w -> Boolean) ->
  VDom a w ->
  VDom a w ->
  Boolean
eqVDom eqAttr eqWidget = deGraft
  where
  deGraft (Grafted l) (Grafted r) = deGraft (runGraft l) (runGraft r)
  deGraft (Grafted l) r = deGraft (runGraft l) r
  deGraft l (Grafted r) = deGraft l (runGraft r)
  deGraft l r = eqNoGraft l r
  eqNoGraft (Text l) (Text r) = l == r
  eqNoGraft (Elem ln le la lc) (Elem rn re ra rc) = ln == rn && le == re
    && eqAttr la ra
    && eqArray deGraft lc rc
  eqNoGraft (Keyed ln le la lc) (Keyed rn re ra rc) =
    ln == rn && le == re && eqAttr la ra && eqArray (eqTuple eq deGraft) lc rc
  eqNoGraft (Widget lw) (Widget rw) = eqWidget lw rw
  eqNoGraft _ _ = false
